import * as h2Api from '../../h2Api'

export const LOAD_FILE_REVIEW = 'LOAD_FILE_REVIEW'
export const LOAD_REVIEWS_FOR_FILE = 'LOAD_REVIEWS_FOR_FILE'
export const REQUEST_FILE_REVIEW = 'REQUEST_FILE_REVIEW'
export const REQUEST_FILE_REVIEW_REQ = 'REQUEST_FILE_REVIEW_REQ'
export const UPDATE_APPROVE_FILE_REVIEW = 'UPDATE_APPROVE_FILE_REVIEW'

export const APPROVE_FILE_REVIEW_REQ = 'APPROVE_FILE_REVIEW_REQ'

export const APPROVE_FILE_REVIEW = 'APPROVE_FILE_REVIEW'

export const reviewsForFile = fileId => dispatch => {
  return dispatch(h2Api.get(`/review/file/${fileId}`)({ type: LOAD_REVIEWS_FOR_FILE }))
}

export const findReview = fileId => dispatch => {
  return dispatch(h2Api.get(`/review/${fileId}`)({ type: LOAD_FILE_REVIEW }))
}

export const requestReview = (fileId, data) => dispatch => {
  return dispatch(
    h2Api.post(`/review/request/${fileId}`, data)({ type: REQUEST_FILE_REVIEW })
  )
}

export const approveFile = (id, data) => dispatch => {
  return dispatch(
    h2Api.put(`/review/approve/${id}`, data)({ type: APPROVE_FILE_REVIEW })
  ).then(v => {
    dispatch({ type: UPDATE_APPROVE_FILE_REVIEW, data: v })

    return Promise.resolve(v)
  })
}
